var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tips-wrapper"},[(_vm.type==='deliveryInfo')?_c('img',{staticClass:"deliveryTip",attrs:{"src":require('@assets/images/deliveryTip.png')},on:{"click":_vm.changeTip}}):_vm._e(),_vm._v(" "),(_vm.showTipFlag)?_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }